__webpack_require__.p = "/pos_system/";